import React from 'react';
import { Button, Icon, Form, Message } from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import moment from 'moment';

export default class CopyQuestions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loader: false,
            questionnaireOptions: [],
            selectedPollId: '',
            statuses: JSON.parse(localStorage.getItem('statuses')) || []
        };

        this.copyPoll = this.copyPoll.bind(this);
        this.copyQuestions = this.copyQuestions.bind(this);
        this.createQuestionCopyRequest = this.createQuestionCopyRequest.bind(this);
        this.shouldCopyQuestionOptions = this.shouldCopyQuestionOptions.bind(this);
        this.getAndCopyAllQuestions = this.getAndCopyAllQuestions.bind(this);
        this.getAndCopyDefaultQuestions = this.getAndCopyDefaultQuestions.bind(this);
        this.getAllQuestionnaire = this.getAllQuestionnaire.bind(this);
        this.handleDropdownChange = this.handleDropdownChange.bind(this);
    }

    componentDidMount() {
        this.getAllQuestionnaire();
    }

    handleDropdownChange(e, { value }) {
        this.setState({ selectedPollId: value });
    }

    getAllQuestionnaire() {
        const statusKeys = ['in progress', 'active', 'archived'];
        const statusLabels = {
            'in progress': 'Kreirane',
            active: 'Aktivne',
            archived: 'Arhivirane'
        };

        const currentPoll = JSON.parse(localStorage.getItem('poll')) || {};
        const currentPollType = currentPoll.pollType;
        const currentPollId = currentPoll.pollId;

        this.setState({ loader: true });

        Promise.all(statusKeys.map(statusKey => {
            const statusObj = this.state.statuses.find(e => e.key === statusKey);

            if (!statusObj) return Promise.resolve(null);

            return axios.get(`/questionnaire/all/${statusObj.value}/`)
                .then(res => ({
                    key: statusKey,
                    label: statusLabels[statusKey],
                    data: (res.data || [])
                        .filter(el =>
                            el.questionnaireType &&
                            el.questionnaireType.id === currentPollType &&
                            el.id !== currentPollId
                        )
                        .map(el => ({
                            ...el,
                            activationDate: el.activationDate
                                ? moment(el.activationDate).format('D. M. YYYY.')
                                : '',
                            endDate: el.endDate
                                ? moment(el.endDate).format('D. M. YYYY.')
                                : ''
                        }))
                }));
        }))
            .then(results => {
                const dropdownOptions = [];

                results
                    .filter(group => group && group.data && group.data.length > 0)
                    .forEach(group => {
                        dropdownOptions.push({
                            key: `header-${group.key}`,
                            text: `--- ${group.label} ---`,
                            value: `header-${group.key}`,
                            disabled: true
                        });

                        group.data.forEach(el => {
                            dropdownOptions.push({
                                key: el.id,
                                value: el.id,
                                text: el.activationDate
                                    ? `${el.name} (${el.activationDate})`
                                    : el.name
                            });
                        });
                    });

                this.setState({
                    questionnaireOptions: dropdownOptions,
                    loader: false
                });
            })
            .catch(err => {
                this.setState({ loader: false });
                toast('Došlo je do greške. Nije moguće prikazati ankete.');
                console.log(err);
            });
    }

    shouldCopyQuestionOptions(question) {
        return question.defaultQuestion || [
            'jedan odgovor',
            'jedan odgovor sa komentarom',
            'viÅ¡e odgovora',
            'viÅ¡e odgovora sa komentarom',
            'više odgovora',
            'više odgovora sa komentarom'
        ].includes(question.questionType.name);
    }

    createQuestionCopyRequest(questionnaireQuestion, newPollId) {
        const { question } = questionnaireQuestion;
        const sourceQuestionOptions = this.shouldCopyQuestionOptions(question) ? questionnaireQuestion.questionOptions : [];
        const questionOptions = (sourceQuestionOptions || [])
            .filter(option => option.value && option.value.trim() !== '')
            .map(option => ({
                value: option.value
            }));

        return axios.post('question/create/', {
            questionnaire: {
                id: newPollId,
                questionnaireStatus: {
                    id: 1
                }
            },
            question: {
                text: question.text,
                cannotRate: question.cannotRate,
                defaultQuestion: question.defaultQuestion,
                section: { id: question.section.id },
                scaleFrom: question.scaleFrom,
                scaleTo: question.scaleTo,
                step: question.step,
                date: question.date,
                questionType: { id: question.questionType.id }
            },
            questionOptions
        });
    }

    copyQuestions(url, newPollId) {
        return axios.get(url)
            .then(async res => {
                const pollQuestions = res.data;

                if (!pollQuestions || pollQuestions.length === 0) {
                    return;
                }

                const requests = pollQuestions.map(q => this.createQuestionCopyRequest(q, newPollId));

                await Promise.all(requests);
            });
    }

    getAndCopyAllQuestions(selectedPollId, newPollId) {
        return this.copyQuestions(`/questionnaire/all/questions/${selectedPollId}/`, newPollId);
    }

    getAndCopyDefaultQuestions(selectedPollId, newPollId) {
        return this.copyQuestions(`/questionnaire/all/default-questions/${selectedPollId}/`, newPollId);
    }

    async copyPoll() {
        const { selectedPollId } = this.state;
        const pollFromStorage = JSON.parse(localStorage.getItem('poll'));
        const newPollId = pollFromStorage && pollFromStorage.pollId;

        if (!selectedPollId) {
            toast('Odaberite anketu za kopiranje.');
            return;
        }

        if (!newPollId) {
            toast('Nova anketa nije pronađena.');
            return;
        }

        this.setState({ loader: true });

        try {
            await this.getAndCopyDefaultQuestions(selectedPollId, newPollId);
            await this.getAndCopyAllQuestions(selectedPollId, newPollId);

            toast('Pitanja su uspješno kopirana.');

            if (this.props.goToQuestionsTab) {
                this.props.goToQuestionsTab();
            }
        } catch (err) {
            console.log(err);
            toast('Došlo je do greške prilikom kopiranja.');
        } finally {
            this.setState({ loader: false });
        }
    }

    render() {
        const { questionnaireOptions, selectedPollId, loader } = this.state;

        return (
            <div>
                <Message>
                    U polju ispod možete odabrati anketu iz koje želite kopirati pitanja.
                    Klikom na dugme „Kopiraj pitanja“, sva pitanja iz odabrane ankete bit će prekopirana u trenutno
                    otvorenu anketu (čiji naziv je prikazan na vrhu stranice).
                </Message>
                <Form>
                    <Form.Field>
                        <label>Odaberite anketu</label>

                        <div style={{
                            width: '50%', display: 'flex', gap: '10px', alignItems: 'flex-end'
                        }}
                        >
                            <div style={{ flex: 1 }}>
                                <Form.Dropdown
                                    placeholder="Odaberite anketu"
                                    options={questionnaireOptions}
                                    value={selectedPollId}
                                    onChange={this.handleDropdownChange}
                                    selection
                                    search
                                    fluid
                                    loading={loader}
                                    noResultsMessage="Nema anketa"
                                />
                            </div>

                            <Button
                                icon
                                labelPosition="right"
                                color="blue"
                                size="small"
                                onClick={this.copyPoll}
                                disabled={loader}
                            >
                                <Icon name="copy" />
                                Kopiraj pitanja
                            </Button>
                        </div>
                    </Form.Field>
                </Form>

                <ToastContainer hideProgressBar />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Poll/AdminPoll/PollPreviewTabs/CopyQuestions.js